export default function toggleView() {
  const buttons = document.querySelectorAll("[data-view-trigger]");
  const sections = document.querySelectorAll("[data-main-view]");

  // Remove all 'active' classes on load
  buttons.forEach((btn) => btn.classList.remove("active"));

  // Check if URL has ?view=...
  const urlParams = new URLSearchParams(window.location.search);
  const currentView = urlParams.get("view") || "default";

  // Function to show the correct content and hide others
  function showView(view) {
    sections.forEach((section) => {
      if (section.getAttribute("data-main-view") === view) {
        section.classList.remove("hidden");
      } else {
        section.classList.add("hidden");
      }
    });
  }

  // Show the current (or default) view
  showView(currentView);

  // Activate all matching buttons
  const activeButtons = document.querySelectorAll(
    `[data-view-trigger="${currentView}"]`
  );
  activeButtons.forEach((button) => button.classList.add("active"));

  // Add click handlers
  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const view = btn.getAttribute("data-view-trigger");

      // Update the URL parameter without reloading
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("view", view);
      window.history.pushState({}, "", newUrl);

      // Remove 'active' from all, then activate all related buttons
      buttons.forEach((b) => b.classList.remove("active"));
      const relatedButtons = document.querySelectorAll(
        `[data-view-trigger="${view}"]`
      );
      relatedButtons.forEach((button) => button.classList.add("active"));

      // Show the clicked (active) view
      showView(view);
    });
  });
}
